module.exports = __webpack_public_path__ + "static/media/Cancel.83b46cbb.svg";